require('../../search/_submit');

jQuery(document).ready(() => {
  $('.select-hymnal').select2({
    placeholder: __('Hymnals / Resources'),
    minimumResultsForSearch: Infinity
  });
});
